import styled from 'styled-components';

const DropdownWrapper = styled.div`
	position: relative;
	display: inline-block;
`;

export default DropdownWrapper;
